import { AnchorHTMLAttributes, FC, ReactNode } from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import classNames from '../utils/classnames';

type CustomLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> &
    RouteComponentProps & {
        children: ReactNode;
        to: string;
        activeClassName?: string;
        className?: string;
        exact?: boolean;
        isActive?: (match: never, location: never) => boolean;
    };

const CustomLink: FC<CustomLinkProps> = ({
    location,
    to = '/',
    isActive,
    exact,
    className,
    children,
    activeClassName,
    staticContext,
    ...rest
}) => {
    const isAbsoluteURL = /^https?:\/\//.test(to);

    if (isAbsoluteURL) {
        return (
            <a className={classNames(className, { activeClassName: location.pathname === to })} href={to} {...rest}>
                {children}
            </a>
        );
    }

    return (
        <NavLink
            activeClassName={activeClassName}
            className={className}
            exact={exact}
            isActive={isActive}
            to={to}
            {...rest}
        >
            {children}
        </NavLink>
    );
};

export default withRouter(CustomLink);
